import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-manufacturer-campaign-instructions',
    templateUrl: './manufacturer-campaign-instructions.component.html',
    styleUrls: ['./manufacturer-campaign-instructions.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class ManufacturerCampaignInstructionsComponent implements OnInit {

  constructor(public modal: NgbActiveModal) { }

  ngOnInit(): void {
  }

}
